import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
  const footerLinks = {
    column1: [
      { href: '/about-us', label: 'Who we are' },
      { href: '/edg', label: 'EDG' },
    ],
    column2: [
      { href: '/one-care', label: 'Platforms' },
      { href: '/research', label: 'Research On' },
    ],
    column3: [
      { href: '#', label: 'T & C' },
      { href: '#', label: 'Privacy Policy' },
    ],
  };

  return (
    <footer className="bg-light ">
      <div className="mx-auto px-6 md:px-10 lg:px-12 py-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">

          {/* Left Section */}
          <div className="md:col-span-4">
            <Link to="/">
              <img src='/assets/images/avexa-white-logo.svg' alt="Avexa Logo" className="h-10 w-auto mb-4" />
            </Link>
            <p className="  leading-relaxed">
              At Avexa, we're building the future of health—
            </p>
            <p className="  leading-relaxed">
              intelligent, connected, and made for everyone.
            </p>
          </div>

          {/* Right Section */}
          <div className="md:col-span-8">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">

              {/* Footer Links */}
              <div className="lg:col-span-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">

                  {/* Column 1 */}
                  {footerLinks.column1.map((link, index) => (
                    <Link
                      key={`col1-${index}`}
                      to={link.href}
                      className=" hover:opacity-80 transition "
                    >
                     | {link.label}
                    </Link>
                  ))}

                  {/* Column 2 */}
                  {footerLinks.column2.map((link, index) => (
                    <Link
                      key={`col2-${index}`}
                      to={link.href}
                      className=" hover:opacity-80 transition "
                    >
                     | {link.label}
                    </Link>
                  ))}

                  {/* Column 3 */}
                  {footerLinks.column3.map((link, index) => (
                    <Link
                      key={`col3-${index}`}
                      to={link.href}
                      className=" hover:opacity-80 transition ">
                     | {link.label}
                    </Link>
                  ))}

                </div>
              </div>

              {/* Contact Button */}
              <div className="lg:col-span-4 flex items-start justify-start lg:justify-end">
                <Link
                  to="/get-in-touch"
                  style={{ backgroundColor: 'var(--secondary-color)', color: 'var(--white)' }}
                  className="inline-flex items-center btn "
                >
                  Contact Us
                </Link>
              </div>
            </div>

            <hr className="border--700 my-6" />

            {/* Bottom Section */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-center">

              <div className="lg:col-span-8">
                <p className=" ">
                  © 2025 Avexa Systems Pvt. Ltd. All Rights Reserved.
                </p>
              </div>

              <div className="lg:col-span-4 flex justify-start lg:justify-end">
                <a
                  href="#"
                  // href="https://www.linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 hover:bg-blue-700 w-10 h-10 rounded-full flex items-center justify-center transition"
                >
                  <FontAwesomeIcon icon={faLinkedinIn} style={{ color: 'var(--white)' }} />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;